<template>
    <div class="mb-6">
        <h3 class="mb-2 font-semibold leading-6 text-gray-500">
            {{ title }}
        </h3>
        <div class="flex items-center justify-between">
            <div class="flex w-full items-center">
                <span
                    v-for="(option, key) in options"
                    :key="key"
                    class="mr-2 flex cursor-pointer items-center justify-center rounded-md border px-3 py-2 text-sm font-medium transition-colors hover:border-indigo-600 focus:outline-none sm:flex-1"
                    :class="{
                        'cursor-not-allowed opacity-25': !option.active,
                        'border-transparent bg-indigo-600 text-white hover:bg-indigo-700 hover:text-white':
                            selectedOption === option.value,
                        'hover:text-indigo-600': selectedOption !== option.value
                    }"
                    @click="selectOption(option.value)"
                >
                    <span>{{ option.label }}</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SnoozeOptions',
    props: {
        title: {
            type: String,
            default: 'Snooze Orders'
        },
        selectedOption: {
            type: Number,
            default: null
        },
        options: {
            type: Array,
            default: () => [
                { label: '5 mins', value: 5, active: true },
                { label: '10 mins', value: 10, active: true },
                { label: '15 mins', value: 15, active: true },
                { label: '30 mins', value: 30, active: true }
            ]
        }
    },
    methods: {
        selectOption(option) {
            if (this.selectedOption === option) {
                this.$emit('option-selected', null);
                return;
            }

            this.$emit('option-selected', option);
        }
    }
};
</script>
